var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72313 3.11309L8.90953 4.29952M1 13H2.19807C3.16798 13 3.65294 13 4.089 12.8194C4.52505 12.6387 4.86801 12.2958 5.55385 11.61L12.0734 5.09048C12.5047 4.6592 12.7203 4.4436 12.8355 4.21096C13.0548 3.7684 13.0548 3.24875 12.8355 2.80618C12.7203 2.57356 12.5047 2.35793 12.0734 1.92666C11.6421 1.49539 11.4265 1.27976 11.1939 1.16449C10.7513 0.94517 10.2316 0.94517 9.78905 1.16449C9.55641 1.27976 9.34081 1.49539 8.90953 1.92666L2.38999 8.44616C1.70416 9.132 1.36125 9.47496 1.18062 9.91104C1 10.347 1 10.832 1 11.8019V13Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIc);
export default __webpack_public_path__ + "static/media/edit_ic.a4197d0eb1bd9ea8c17c2e246aa007f8.svg";
export { ForwardRef as ReactComponent };